module.exports = __webpack_public_path__ + "static/media/NX.1afa72d1.png";